import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ConfirmCancelRegistrationModal({
  show,
  onClose,
  activityId,
  activityName,
  onConfirm,
}) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
  }, [show]);

  const handleClose = () => {
    setSuccess(false);
    setErrorMsg("");
    onClose();
  };

  const confirmHandler = async () => {
    setLoading(true);
    setErrorMsg("");

    try {
      const result = await onConfirm(activityId); // { success, message }

      if (result.success) {
        setSuccess(true);
      } else {
        setErrorMsg(result.message);
      }
    } catch (error) {
      setErrorMsg("Failed to cancel registration");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay d-flex justify-content-center align-items-center">
      <div className="modal-animate bg-white rounded shadow-lg p-4 p-md-5 position-relative text-center modal-card">
        {!success && (
          <button
            className="btn-close position-absolute"
            style={{ top: 14, right: 14 }}
            onClick={handleClose}
            disabled={loading}
          />
        )}

        {!success ? (
          <>
            <div className="text-danger fs-1 mb-2">⚠️</div>
            <h4 className="fw-bold text-danger mb-2">
              Confirm Cancellation
            </h4>

            <div
              className="bg-light small rounded py-2 px-3 mt-2 mb-3 text-secondary"
              style={{
                fontSize: "13px",
                borderLeft: "4px solid #dc3545",
              }}
            >
              If you confirm, you will be removed from this activity and
              <strong className="text-danger d-block mt-1">
                you will NOT be able to register again.
              </strong>
            </div>

            <h6 className="fw-semibold text-dark mb-4">
              {activityName}
            </h6>

            {errorMsg && (
              <div className="text-danger small mb-3">
                {errorMsg}
              </div>
            )}

            <button
              className="btn btn-danger w-100 fw-semibold py-2 d-flex align-items-center justify-content-center mb-2"
              onClick={confirmHandler}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                "Confirm Cancellation"
              )}
            </button>

            <button
              className="btn btn-outline-secondary w-100 fw-semibold py-2"
              onClick={handleClose}
              disabled={loading}
            >
              Keep Registration
            </button>
          </>
        ) 
        : (
          <>
            <div className="text-success fs-1 mb-3"></div>
            <h5 className="fw-bold text-success mb-2">
              Registration Cancelled
            </h5>

            <p className="text-secondary small mb-4">
              You have been removed from:
              <span className="fw-semibold text-dark rounded-5 d-block p-1 mt-1">
                "{activityName}"
              </span>
              <span className="text-danger d-block mt-2">
                You cannot register for this activity again.
              </span>
            </p>

            <button
              className="btn btn-success w-100 fw-semibold py-2"
              onClick={handleClose}
            >
              Done
            </button>
          </>
        )
        }
      </div>

      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.65);
          z-index: 2000;
          animation: fadeIn 0.25s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (max-width: 480px) {
          .modal-card {
            width: 95% !important;
            padding: 20px !important;
          }
        }
      `}</style>
    </div>
  );
}
